import { COLLECTION_KINDS, KIND_METADATA, type CollectionKind } from "@atelier/config";
import { useWizard } from "@/stores/wizard";
import { ContractSourceLink } from "@/components/SourceLink";
import { cn } from "@/lib/cn";

/**
 * Wizard step 0 — pick the collection kind. One radio tile per
 * COLLECTION_KINDS entry; copy + contract name come from KIND_METADATA so
 * adding a new kind is a one-file change.
 */
export function Step0Type() {
  const kind = useWizard((s) => s.kind);
  const set = useWizard((s) => s.set);
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {COLLECTION_KINDS.map((k) => {
        const meta = KIND_METADATA[k];
        const selected = kind === k;
        return (
          <div
            key={k}
            role="radio"
            aria-checked={selected}
            tabIndex={0}
            onClick={() => set("kind", k as CollectionKind)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                set("kind", k as CollectionKind);
              }
            }}
            className={cn(
              "card flex cursor-pointer flex-col gap-3 border-2 text-left transition-colors",
              selected ? "border-primary" : "border-border hover:border-muted-foreground",
            )}
          >
            <div className="text-lg font-semibold leading-tight whitespace-nowrap">
              {meta.title}
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">{meta.body}</p>
            <div className="mt-auto space-y-1 border-t border-border pt-3 text-[11px] text-muted-foreground">
              <div>
                contract: <ContractSourceLink name={meta.contract} />
              </div>
              <div>{meta.deploys}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
